import image1 from '../assets/booking1.png'
import image2 from '../assets/booking2.png'
import image3 from '../assets/booking3.png'
import image4 from '../assets/booking4.png'
import image5 from '../assets/booking5.png'
import image6 from '../assets/booking6.png'
import { icons } from './icons'

export const cars = [
  {
    image: image1,
    icon : icons.like1
  },
  {
    image: image2,
    icon : icons.like2
  },
  {
    image: image3,
    icon : icons.like3
  },
  {
    image: image4,
    icon : icons.like4
  },
  {
    image: image5,
    icon : icons.like5
  },
  {
    image: image6,
    icon : icons.like6
  },
  {
    image: image1,
    icon : icons.like7
  },
  {
    image: image2,
    icon : icons.like8
  },
  {
    image: image3,
    icon : icons.like9
  },
  {
    image: image4,
    icon : icons.like10
  },
  {
    image: image5,
    icon : icons.like11
  },
  {
    image: image6,
    icon : icons.like12
  }
]